export default "__VITE_ASSET__DjoDzO64__"